// Note: I tried to get these product keys lists automatically from the BE (using the /markets/products endpoint),
// but there are a lot of products which are no longer kept in the FE code base. Therefore the
// solution I've found is to maintain this list of product keys manually and
// use it to filter out the information coming from the BE
export type ProductGroupKey =
  | 'liability'
  | 'liabilityNxt'
  | 'animalNxt'
  | 'contentsNxt'
  | 'legal'
  | 'dental'
  | 'contents'
  | 'animal_de'
  | 'bike_de'
  | 'car_de'
  | 'travel_de'
// This is a utility object to generate the type and the array below
const baseProductKeyObject = {
  pet_health_v1_luko_to_getsafe_de: '',
  liability_basic_neodigital_de: '',
  liability_premium_basic_neodigital_de: '',
  legal_comfort_3_basic_roland_de: '',
  legal_basis_3_basic_roland_de: '',
  unified_legal_comfort_3_basic_roland_de: '',
  contents_premium_basic_neodigital_de: '',
  contents_comfort_basic_neodigital_de: '',
  dog_liability_basic_de: '',
  bike_theft_comfort_basic_neodigital_de: '',
  bike_theft_premium_basic_neodigital_de: '',
  unified_bike_theft_premium_basic_neodigital_de: '',
  car_comfort_basic_iptiq_de: '',
  dental_ottonova_75_plus_de: '',
  dental_ottonova_90_plus_de: '',
  dental_ottonova_100_plus_de: '',
  liability_v1_getsafe_de: '',
  contents_v1_getsafe_de: '',
  dog_liability_v1_getsafe_de: '',
  household_v1_getsafe_at: '',
  dog_liability_v1_getsafe_at: '',
  liability_v1_getsafe_at: '',
  pet_health_v1_getsafe_de: '',
  pet_health_v2_getsafe_de: '',
  travel_health_v1_ergo_de: '',
  travel_health_v1_berlin_direkt_de: '',
  dental_v1_getsafe_de: '',
  // [hygen-marker] product key
} as const

export type BaseProductKey = keyof typeof baseProductKeyObject
export const baseProdKeys = Object.keys(baseProductKeyObject) as BaseProductKey[]

const _mgaProductKeyObject = {
  mga_occupational_disability_de: '',
  mga_private_pension_de: '',
  mga_private_health_de: '',
  mga_child_saving_de: '',
  mga_term_life_insurance_de: '',
  mga_legal_roland_de: '',
  mga_public_health_de: '',
  mga_dental_de: '',
} as const
type MGAProductKey = keyof typeof _mgaProductKeyObject

// This is a utility object to generate the type and the array below
const extensionProductKeyObject = {
  liability_drones_neodigital_de: '',
  liability_premium_drones_neodigital_de: '',
  legal_comfort_3_tenant_roland_de: '',
  legal_comfort_3_criminal_roland_de: '',
  legal_basis_3_tenant_roland_de: '',
  legal_basis_3_criminal_roland_de: '',
  contents_premium_glass_neodigital_de: '',
  contents_premium_bike_theft_neodigital_de: '',
  contents_premium_natural_disasters_neodigital_de: '',
  contents_comfort_glass_neodigital_de: '',
  contents_comfort_bike_theft_neodigital_de: '',
  contents_comfort_natural_disasters_neodigital_de: '',
  dog_liability_premium_de: '',
  bike_theft_comfort_comprehensive_neodigital_de: '',
  bike_theft_premium_comprehensive_neodigital_de: '',
} as const
export type ExtensionProductKey = keyof typeof extensionProductKeyObject
export const extProdKeys = Object.keys(extensionProductKeyObject) as ExtensionProductKey[]
export type ProductKey = BaseProductKey | ExtensionProductKey | MGAProductKey | 'test_product_key'
